export default "__VITE_PUBLIC_ASSET__6505e2aa__"